export default __webpack_public_path__ + "static/media/Languages_Icon.eca162f9.png";